import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-down\">\r\n<path d=\"M19.4,8.1c-0.2-0.2-0.6-0.2-0.8,0L12,14.7L5.4,8.1c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8l7,7\r\n\tc0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l7-7C19.7,8.7,19.7,8.3,19.4,8.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol